import { useTranslation } from 'react-i18next';

import { RequestFinalScreen } from 'components';

const CreditRequestExistsPage = () => {
  const { t } = useTranslation();

  return (
    <RequestFinalScreen
      title={t('credit.request.exists.title')}
      description={t('credit.request.exists.description')}
    />
  )
}

export default CreditRequestExistsPage;